<template>
  <div class="auth-page" :class="{ mobile: isMobileLayout }">
    <div class="auth-card">
      <div class="register-header">
        <div class="register-top">
          <b>注册影院会员</b>
        </div>
      </div>

      <el-form
        class="register-form"
        ref="registerFormRef"
        :model="registerForm"
        :rules="registerFormRules"
        :label-width="isMobileLayout ? 'auto' : '96px'"
        :label-position="isMobileLayout ? 'top' : 'right'"
      >
        <el-form-item label="用户名" prop="userName">
          <el-input v-model="registerForm.userName" placeholder="请输入用户名" clearable></el-input>
        </el-form-item>
        <el-form-item label="用户密码" prop="password">
          <el-input v-model="registerForm.password" type="password" placeholder="请输入密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="registerForm.confirmPassword" type="password" placeholder="请输入确认密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="phoneNumber">
          <el-input v-model="registerForm.phoneNumber" type="text" aria-placeholder="请输入手机号" clearable></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio v-model="gender" label="1">男</el-radio>
          <el-radio v-model="gender" label="0">女</el-radio>
        </el-form-item>
        <el-form-item class="register-actions">
          <el-button class="register-btn" type="primary" @click="register">
             同意以下协议并注册</el-button>
          <el-button class="register-btn" @click="$router.push('/login')">
            返回登录
          </el-button>
        </el-form-item>
        <el-form-item id="protocal" class="protocol-row">
          <el-link type="primary" style="line-height: 14px;">《影院注册协议》</el-link>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: "Register",
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
        // password 是表单上绑定的字段
      } else if (value !== this.registerForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    let checkMobile = (rule, value, cb) => {
      const regMobile = /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
      if (regMobile.test(value)){
        return cb()
      }
      cb(new Error('请输入合法的手机号码'))
    }
    return {
      gender: '1',
      registerForm: {
        userName: '',
        password: '',
        confirmPassword: '',
        phoneNumber: '',
        sex: ''
      },
      registerFormRules: {
        userName: [
          { required: true, message: "请输入用户名称", trigger: "blur"},
          { min: 2, max: 20, message: "用户名称长度在2到20个字符之间", trigger: "blur"}
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur"},
          { min:6, max: 16, message: "长度在6到16个字符之间", trigger: "blur"}
        ],
        confirmPassword: [
          { required: true, validator: validatePass, message: "两次密码输入不一致", trigger: "blur"},
        ],
        phoneNumber: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur'}
        ]
      }
    }
  },
  computed: {
    isMobileLayout() {
      return this.$platform.isMobile
    }
  },
  methods: {
    register() {
      this.$refs.registerFormRef.validate(async valid => {
        if(!valid) return
        this.registerForm.sex = this.gender === '1'
        axios.defaults.headers.post['Content-Type'] = 'application/json'
        const { data: res} = await axios.post('sysUser/register', JSON.stringify(this.registerForm));
        if(res.code !== 200) return this.$message.error(res.msg);

        this.$message.success("注册完成！");
        this.$router.push('/login')
        this.$refs.registerFormRef.resetFields()
      })
    },
    toWelcome() {
      this.$router.push('/welcome')
    }
  }
}
</script>

<style scoped>
.auth-page{
  width: 100%;
  min-height: 100%;
  padding: 32px 16px;
  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
  display: flex;
  justify-content: center;
}

.auth-card{
  width: 100%;
  max-width: 760px;
  background: #fff;
  border-radius: 20px;
  padding: 32px 40px;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);
}

.register-top {
  font-size: 28px;
}

.register-header {
  width: 100%;
  text-align: center;
  margin: 0 0 28px 0;
}

.register-actions {
  margin-top: 20px;
  display: flex;
  gap: 12px;
}

.register-btn {
  font-size: 18px;
}

.protocol-row {
  margin-bottom: 0;
}

.auth-page.mobile {
  padding: 16px;
}

.auth-page.mobile .auth-card {
  padding: 24px 18px;
  border-radius: 16px;
}

.auth-page.mobile .register-top {
  font-size: 24px;
}

.auth-page.mobile .register-actions {
  flex-direction: column;
}

.auth-page.mobile .register-btn {
  width: 100%;
  margin-left: 0;
}
</style>
